import tenantUtils from '@utils';
import { getTimeDateString } from '../../../utility/date';
import { t } from 'i18next';

const getLeadsStaffFilters = () => [
  {
    type: 'unitSelect',
    label: 'Search By',
    subList: [
      { label: t('Listing ID'), key: 'listing_id', queryParamKey: 'q[interests_listing_id_eq]' },
      { label: t('REGA Ad License Number'), key: 'ad_license', queryParamKey: 'q[interests_listing_ad_license_eq]' },
      { label: t('Lead ID'), key: 'lead_id', queryParamKey: 'q[lead_client_id_eq]' },
      { label: t('Lead Name'), key: 'lead_name', queryParamKey: 'q[client_name_start]' },
    ],
  },
  {
    label: 'Lead Received',
    key: 'lead_received',
    queryParamKey: ['q[created_at_gteq]', 'q[created_at_lteq]'],
    placeholder: 'Select Date Range',
    type: 'dateRange',
    getOptionLabel: (value) => {
      return value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - ');
    },
  },
  {
    label: 'Last Interaction',
    key: 'last_interaction',
    queryParamKey: ['q[updated_at_gteq]', 'q[updated_at_lteq]'],
    placeholder: 'Select Date Range',
    type: 'dateRange',

    getOptionLabel: (value) => {
      return value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - ');
    },
  },
  // {
  //   type: 'unitSelect',
  //   // componentType: 'date',
  //   label: 'Search By',
  //   subList: [
  //     { label: 'Lead Received', key: 'created_at', queryParamKey: 'q[listing_id_eq]', maxLength: 9 },
  //     { label: 'Last Interaction', key: 'updated_at' },
  //   ],
  // },

  // {
  //   key: 'product_id',
  //   queryParamKey: 'q[product_id_in][]',
  //   label: 'Task Performed',
  //   labelProps: { muted: true },
  //   placeholder: 'Select Task Performed',
  //   type: 'select',
  //   showTag: true,
  //   singleValue: true,
  //   getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'product_title'),
  // },
  // {
  //   key: 'product_id',
  //   queryParamKey: 'q[product_id_in][]',
  //   label: 'Planned Task',
  //   labelProps: { muted: true },
  //   placeholder: 'Select Planned Task',
  //   type: 'select',
  //   showTag: true,
  //   singleValue: true,
  //   getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'product_title'),
  // },
];
export default getLeadsStaffFilters;
